const CHUNK_ERROR_PATTERN =
  /Outdated Optimize Dep|Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk|ChunkLoadError|CSS chunk load failed|global is not defined/i

const toErrorText = (errorLike) => {
  if (typeof errorLike === 'string') return errorLike
  const message =
    typeof errorLike?.message === 'string' ? errorLike.message : ''
  const stack = typeof errorLike?.stack === 'string' ? errorLike.stack : ''
  return `${message} ${stack}`
}

export const isChunkLikeError = (errorLike) =>
  CHUNK_ERROR_PATTERN.test(toErrorText(errorLike))

